import React from 'react'

const SvgComponent = props => (
  <svg width={66} height={66} {...props}>
    <defs>
      <linearGradient
        x1="7.569%"
        y1="110.903%"
        x2="78.899%"
        y2="7.982%"
        id="blockchain__prefix__a"
      >
        <stop stopColor="#FAC9E3" stopOpacity={0.4} offset="0%" />
        <stop stopColor="#E3486A" offset="97.936%" />
      </linearGradient>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="155.653%"
        y2="90.79%"
        id="blockchain__prefix__b"
      >
        <stop stopColor="#FBA4B5" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="155.653%"
        y1="90.79%"
        x2="-12.039%"
        y2="1.214%"
        id="blockchain__prefix__c"
      >
        <stop stopColor="#F57B94" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle
        fill="url(#blockchain__prefix__a)"
        opacity={0.166}
        cx={33}
        cy={33}
        r={33}
      />
      <g stroke="#E98699">
        <path
          d="M11.22 33.028l10.734 3.66 10.071-3.64-10.743-3.224-10.062 3.204zM22.442 15.839l10.7 3.648 10.331-3.693-10.206-3.187-10.825 3.232zM33.63 33.139l11.032 3.87 10.347-3.982-11.075-3.443-10.304 3.555z"
          strokeWidth={0.75}
          fill="#F8F8F8"
          opacity={0.972}
        />
        <g strokeWidth={0.9}>
          <path
            d="M.45.883v12.775l10.885 3.756V4.394L.45.884z"
            fill="url(#blockchain__prefix__b)"
            opacity={0.666}
            transform="translate(10.09 32.749)"
          />
          <path
            d="M11.957.631v13.027l10.886 3.756V4.387L11.957.631z"
            fill="url(#blockchain__prefix__c)"
            transform="matrix(-1 0 0 1 44.89 32.749)"
          />
        </g>
        <g strokeWidth={0.9}>
          <path
            d="M.45.883v12.775l10.885 3.756V4.394L.45.884z"
            fill="url(#blockchain__prefix__b)"
            opacity={0.666}
            transform="translate(21.278 15.548)"
          />
          <path
            d="M11.957.631v13.027l10.886 3.756V4.387L11.957.631z"
            fill="url(#blockchain__prefix__c)"
            transform="matrix(-1 0 0 1 56.079 15.548)"
          />
        </g>
        <g strokeWidth={0.9}>
          <path
            d="M.45.631v13.027l10.885 3.756V4.387L.45.631z"
            fill="url(#blockchain__prefix__c)"
            opacity={0.702}
            transform="translate(32.999 32.93)"
          />
          <path
            d="M11.957.631v13.027l10.886 3.756V4.387L11.957.631z"
            fill="url(#blockchain__prefix__b)"
            transform="matrix(-1 0 0 1 67.8 32.93)"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default SvgComponent
